import getSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import { isUnifiedSearchView } from 'mini-mail-list-store/lib/selectors/isUnifiedSearchView';
import { shouldShowMailListHeaderForFolderId } from '../../utils/mailList/shouldShowMailListHeaderForFolderId';

export const shouldShowListHeader = () => {
    const tableView = getSelectedTableView();

    if (isUnifiedSearchView()) {
        return false;
    }

    return !!(
        tableView?.tableQuery &&
        shouldShowMailListHeaderForFolderId(tableView?.tableQuery?.folderId)
    );
};
